import classNames from 'classnames';
import { observer } from 'mobx-react';
import * as style from './ScoreLineShared.module.less';
import { RuleType } from '@assets/model/ScoreUtils';
export type ScoreLinePosition = 'under' | 'over' | 'in-range';

export type ScoreEntry = {
    didScore: boolean;
    rawValue: number;
};

export type ScoreDisplay = {
    value: string;
    center: string;
    min: string;
    max: string;
};

interface IScoreLineProps {
    entries: ScoreEntry[];
    display: ScoreDisplay;
    rule: RuleType;
    className?: string;
}

export const ScoreLineGreaterThan = observer((p: IScoreLineProps) => {
    const disp = p.display;
    //score range is 0 to 1

    //0 - 0.15 IS under - > right in center no scaling
    //0.15 - 0.85 is in range -> scale to 0 - 1
    //0.85 - 1 is over -> right in center no scaling

    const edge = 0.1; //Note CSS also defined this value as --edge-range: 10%;
    const halfEdge = edge / 2;
    var tooltipColor = null;
    const noCls = style.tooltipRed;
    const yesCls = style.tooltipGreen;

    const entries = p.entries.map((entry, i) => {
        var classTooltip = null;
        var posX = -1;

        const r = p.rule;

        var dist = (entry.rawValue - r.range[0]) / (r.range[1] - r.range[0]);

        if (dist > 1.1) {
            posX = 1 - halfEdge;
        } else if (dist < 0.0) {
            posX = halfEdge;
        } else {
            posX = edge + dist * (1 - edge * 2);
        }

        if (!entry.didScore) {
            classTooltip = noCls;
        } else {
            classTooltip = yesCls;
        }
        //}

        const posXStr = (posX * 100).toFixed(0).toString() + '%';
        const cls = classNames(
            style.scoreLineEntry,
            classTooltip,
            style.tooltip_tip
        );
        return (
            <div key={i} className={cls} style={{ left: posXStr }}>
                {disp.value}
            </div>
        );
    });

    const cls = classNames(
        style.scoreLine,
        style.scoreLineGreaterThan,
        p.className
    );
    return (
        <>
            <div className={style.scoreLineContainer}>
                <div className={cls}>
                    <div className={style.middleLabel}>
                        {'>'} {disp.center}
                    </div>
                    <div className={style.leftLabel}>{disp.min}</div>
                    <div className={style.rightLabel}>{disp.max}</div>
                    <div className={style.edgeLineGreen}></div>
                    <div className={style.edgeLineRed}></div>
                    {entries}
                </div>
            </div>
        </>
    );
});
